<template src="./detail.html"></template>

<script>

import NewsService from 'Services/NewsService';

export default {
  data() {
    return {
      news: {},
    };
  },

  created() {
    this.listSlideBars();
  },

  methods: {
    listSlideBars() {
      NewsService.show(this.$route.params.id)
        .then((response) => {
          this.news = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
